import React, { useMemo, useState } from 'react'
import { useRecoilState } from 'recoil';
import { searchState } from '../state/searchState';
import { debounce } from 'lodash';
import styled from 'styled-components';

const SearchBoxInput = styled.input`
    border: none !important;
    background: #fff;
    color: #000;
    width: 98%;
    margin: 0;
    height: 50px;
    border-radius: 12px;
    padding: 2px 8px;
  }
  
  :hover {
    background-color: #EBEBEB !important;
  }

  ::placeholder {
      color: rgb(128, 128, 128) !important;
  }
`


export const SearchInput = () => {
    const [, setText] = useRecoilState(searchState);
    const [localSearch, setlocalSearch] = useState("");


    useMemo(
        debounce(() => {
            setText(localSearch)
        }, 300),
        [localSearch]
    )

    return (
        <SearchBoxInput
            type="text"
            value={localSearch} onChange={(e) => setlocalSearch(e.target.value)}
            placeholder="Ricerca nel Tariffario..."
        />

    );
}
